import React from "react";



const WhyInvest = ({handleView}) => {
    return(
        <div className="why-invest">
            <div className="">
            </div>
            <div className="why-invest-text">
            <h1>
            Why grow your wealth with Checkoff Finance?
            </h1>
            <div className="why-invest-text-inner pt-2">
            <div className="dot"></div>
            <div>Earn from 10 to 20% interest per annum</div>
            </div>
            <div className="why-invest-text-inner">
            <div className="dot"></div>
            <div>Start with a minimum of ₦200,000</div>
            </div>
            <div className="why-invest-text-inner">
            <div className="dot"></div>
            <div>Interests paid directly into your account <br/> monthly, quarterly or at maturity</div>
            </div>
            <div className="why-invest-text-inner">
            <div className="dot"></div>
            <div>We are regulated by CBN</div>
            </div>
            <div className="why-invest-text-inner">
            <div className="dot"></div>
            <div>Minimum tenor of 90 days</div>
            </div>
            <div className="why-invest-text-inner">
            <div className="dot"></div>
            <div>Low-risk due to nature of business</div>
            </div>
            <button onClick={handleView} className="btn btn-primary">Get Started</button>
            </div>
        </div>
    )
}

export default WhyInvest